export const KANDA_LEGAL_URL = `https://storage.googleapis.com/ideal-terms/checkout%20T%26C's%20Website%20%2B%20Service.pdf`;
